module.exports = __webpack_public_path__ + "img/2024-09-19d_5.8adb1d78.jpg";